"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.useGridRefresh = function () {
    var _a = React.useState(0), refresh = _a[0], setRefreshCounter = _a[1];
    return [
        refresh,
        function () {
            setRefreshCounter(refresh + 1);
        },
    ];
};
